<template>
  <v-app>
    <v-layout class="rounded rounded-md">
      <v-app-bar v-if="isMobile" class="gradient" height="50">
        <template v-slot:prepend>
          <v-app-bar-nav-icon color="white" @click="drawer = !drawer"></v-app-bar-nav-icon>
        </template>
        <v-toolbar-title class="text-white"><b>Maxime Ladies Raid</b></v-toolbar-title>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer">
        <NavigationDrawer></NavigationDrawer>
      </v-navigation-drawer>

      <v-main id="main">
        <div class="pa-3">
          <router-view></router-view>

        </div>
      </v-main>
    </v-layout>
  </v-app>
</template>

<script>
import NavigationDrawer from "@/components/App/NavigationDrawer.vue";
export default {
  name: "App",
  components: {
    NavigationDrawer,
  },

  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  created() {
    if (!this.isMobile) {
      this.drawer = true;
    }
    this.$store.dispatch("fetchRunners");
    setInterval(() => {
      this.$store.dispatch("fetchRunners");
    }, 10000);
    //this.$store.state.loading = true;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/global.scss";
</style>
